import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";

import moment from "moment";

import { Link } from "react-router-dom";

import { H1, H5, P } from "../../../atoms/Texts";

import * as Icon from "react-feather";

import { toastError } from "../../../../shared/helpers";

import { Table } from "../../../organisms/Table";
import { Badge } from "../../../atoms/Buttons";
import OrgDetails from "../../../organisms/OrgDetails";
import DeleteModal from "../../../organisms/DeleteModal";
import { demoContext } from "../../../../shared/store/contexts";

const OrgActions = ({
  orgId,
  org_id,
  isOwner,
  initiativeId,
  orgName,
  organization,
}) => {
  const [showOrg, setShowOrg] = useState(false);
  const toggleOrgeModal = () => setShowOrg(!showOrg);

  const [removeOrg, setRemoveOrg] = useState(false);

  const toggleRemoveOrg = () => setRemoveOrg(!removeOrg);

  const handleRemoveOrg = () => {
    toastError("No actions are carried out in a DEMO");
    toggleRemoveOrg();
  };

  return (
    <div>
      <div className="flex gap-x-4">
        <Badge
          onClick={toggleOrgeModal}
          className="uppercase"
          p="8px 30px"
          bg="#F6F6F6"
          color="#282828"
          fontSize="10px"
          fontFamily="medium"
        >
          View
        </Badge>

        {isOwner && (
          <Badge
            onClick={toggleRemoveOrg}
            disabled={orgId === org_id}
            className="uppercase"
            p="8px 24px"
            bg="#FFE2E7"
            color="#AD283D"
            fontSize="10px"
            fontFamily="medium"
          >
            Remove
          </Badge>
        )}
      </div>

      {showOrg && (
        <OrgDetails
          organization={organization}
          orgId={orgId}
          closeModal={toggleOrgeModal}
        />
      )}

      {removeOrg && (
        <DeleteModal
          header="Remove Organization"
          closeModal={toggleRemoveOrg}
          cta="Remove"
          action={handleRemoveOrg}
          warning={`Removing ${orgName} from this initiative is irreversible, are you certain of this action?`}
        />
      )}
    </div>
  );
};

const ViewOrganizations = () => {
  const { id, initiativeId } = useParams();
  const { initiative } = useContext(demoContext);

  const [currentPage, setCurrentPage] = useState(0);

  const isOwner = initiative.organizationId === id;

  const organizations = initiative.organizations;

  const invitedOrg = initiative.organizations[0];
  const ownerOrg = initiative.organizations[1];

  return (
    <div className="w-full">
      <section
        style={{
          background: "#f8f6fe",
        }}
        className="pt-16 pb-4 px-4 lg:px-6 xl:px-10 "
      >
        <div className="">
          <div className="flex-1">
            <H1 fontSize="26px" color="#22202D" className="">
              Organizations
            </H1>

            <Link to={`/dashboard/organization/${id}/initiatives`}>
              <div
                className="mt-16 flex items-center cursor-pointer"
                style={{
                  width: "fit-content",
                }}
              >
                <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
                <P color="#1E202A" fontSize="14px" smallSize="14px">
                  Back to Initiatives
                </P>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className=" px-4 lg:px-10 my-8">
        <H5 fontFamily="medium" className="flex-shrink-0 flex-grow mb-4">
          All Organizations
        </H5>

        <OrgTable
          isOwner={isOwner}
          org_id={id}
          initiativeId={initiativeId}
          data={organizations}
          loading={false}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          ownerOrg={ownerOrg}
          invitedOrg={invitedOrg}
        />
      </section>
    </div>
  );
};

const OrgTable = ({
  isOwner,
  org_id,
  data,
  loading,
  currentPage,
  setCurrentPage,
  initiativeId,
  invitedOrg,
  ownerOrg,
}) => {
  const columns = [
    {
      accessor: "name",
      Header: "Organization Name",
      Cell: ({ value }) => {
        return (
          <P color="#252733" className=" flex items-center">
            {value}
          </P>
        );
      },
    },
    {
      accessor: "email",
      Header: "Email Address",
      Cell: ({ value }) => (
        <P color="#252733" className="">
          {value || "n/a"}
        </P>
      ),
    },
    {
      accessor: "noOfCases",
      Header: "No. of cases",
      Cell: ({ value }) => (
        <Badge
          p="8px 30px"
          bg="#EFECFF"
          color="#2220A9"
          fontSize="12px"
          fontFamily="normal"
        >
          {value || 0}
        </Badge>
      ),
    },
    {
      accessor: "joinDate",
      Header: "Date Joined",
      Cell: ({ value }) => (
        <div>
          <p className="">{moment(value).format("ll")}</p>
        </div>
      ),
    },

    {
      accessor: "Actions",
      Header: "Actions",
      Cell: ({ row }) => {
        const orgName = row?.original?.name;

        return (
          <div>
            <OrgActions
              isOwner={isOwner}
              orgId={row?.original?.organization?.id}
              org_id={org_id}
              initiativeId={initiativeId}
              orgName={orgName}
              organization={orgName === invitedOrg.name ? invitedOrg : ownerOrg}
            />
          </div>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      data={data}
      loading={loading}
      current_page={currentPage}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default ViewOrganizations;
